import { useEffect, useState } from "react";
import { _Process } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SelectSubProcessType = ({ idSelector, onChange, label }: Props) => {

    const { instance, setLista, lista} = useDataBean(_Process)

    const [id, setID] = useState<number>(null);

    useEffect(() => {
        setID(idSelector);
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        setID(e);
        onChange(e);
    };

    const getLista = () => {
        instance.getProcessSubTypeConstantsList(null).then(
            (resp)=>{
                setLista(resp)
            }
        ).catch(
            err=>{toast.error(err)}
        )
    }

    return (
        <>
            <label>{label ? label : 'Subtipo de Proceso'}</label>
            <select className="form-select" value={id} onChange={(e) => {
                const value = e.target.value ? Number(e.target.value) : null
                setValue(value)
            }}>
                <option value={""} >...</option>
                {lista &&
                    lista.map((item: any) => {
                        return (
                            <option key={item.DataBeanProperties.Value} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}